import TagManager, { DataLayerArgs, TagManagerArgs } from 'react-gtm-module';

export type EventName =
  | 'Screen_AhaSupply'
  | 'AhaSupply_search'
  | 'AhaSupply_click_Category_detail'
  | 'AhaSupply_click_Item_detail'
  | 'AhaSupply_click_Mycart'
  | 'Screen_Category_details'
  | 'Category_detail_scroll'
  | 'Category_detail_switch_tab'
  | 'Category_detail_click_Item_detail'
  | 'Category_detail_click_Mycart'
  | 'Screen_Item_detail'
  | 'Item_detail_click_Type'
  | 'Item_detail_click_Distributor'
  | 'Item_detail_click_Action_review'
  | 'Item_detail_click_Plus_Minus'
  | 'Item_detail_click_Action_final'
  | 'Item_detail_click_Mycart'
  | 'Screen_Distributor'
  | 'Distributor_search'
  | 'Distributor_scroll'
  | 'Distributor_switch_tab'
  | 'Distributor_click_Item_detail'
  | 'Distributor_click_Mycart'
  | 'Screen_Mycart'
  | 'Mycart_click_Plus_Minus'
  | 'Mycart_click_Delete'
  | 'Mycart_choice_EInvoice'
  | 'Mycart_click_Addmore'
  | 'Mycart_click_Promocode'
  | 'Mycart_click_Paymentmethod'
  | 'Mycart_click_btn_Order';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID as string,
};

const shouldTrackEvent = () => {
  return process.env.REACT_APP_ENABLE_TRACKING_EVENT === 'true';
};

export const initGTM = (customTagManagerArgs?: Omit<TagManagerArgs, 'gtmId'>) =>
  TagManager.initialize({ ...tagManagerArgs, ...customTagManagerArgs });

export const logEvent = (
  event: EventName,
  eventParameters: DataLayerArgs['dataLayer'] = {}
) => {
  try {
    console.log(
      shouldTrackEvent() ? '[Tracked]' : '[Not Tracked]',
      event,
      eventParameters
    );
    if (shouldTrackEvent()) {
      TagManager.dataLayer({
        dataLayer: {
          event,
          ...eventParameters,
        },
      });
    }
  } catch (error) {
    console.log('TRACKING ERROR: ', error);
  }
};
